// extracted by mini-css-extract-plugin
module.exports = {"ldsroller":"LoadingComponent-ldsroller","absoluteCenter":"LoadingComponent-absoluteCenter"};